import script from "./righttBars.vue?vue&type=script&setup=true&lang=js"
export * from "./righttBars.vue?vue&type=script&setup=true&lang=js"

import "./righttBars.vue?vue&type=style&index=0&id=3ac74180&scoped=true&lang=css"
script.__scopeId = "data-v-3ac74180"

export default script